function handleHeaderScroll() {
    const header = document.querySelector('header');
    const scrollOffset = 100;

    if (window.scrollY >= scrollOffset) {
        header.classList.add('active');
        if (header.classList.contains('inicio')) {
            header.classList.remove('inicio');
            header.classList.add('inicio-disabled');
        }
    } else {
        header.classList.remove('active');
        if (header.classList.contains('inicio-disabled')) {
            header.classList.add('inicio');
            header.classList.remove('inicio-disabled');
        }
    }
}

window.addEventListener('scroll', handleHeaderScroll);


document.addEventListener("DOMContentLoaded", () => {
    const openMenu = document.querySelector(".hamburguer__menu");
    const closeMenu = document.querySelector(".close__hamburguer");
    const menu = document.querySelector(".header__area_enlaces");
    const backgroundBlack = document.querySelector(".background__black");

    openMenu.addEventListener("click", () => {
        menu.classList.add("is-open");
        backgroundBlack.classList.add("activo");
    });

    closeMenu.addEventListener("click", () => {
        menu.classList.remove("is-open");
        backgroundBlack.classList.remove("activo");
    });

    backgroundBlack.addEventListener("click", () => {
        menu.classList.remove("is-open");
        backgroundBlack.classList.remove("activo");
    });
})
